import { Avatar } from '@mui/material';
import { useState } from 'react';

import type { CatalogApp } from '../api/queries';
import { logoDomain } from '../lib/logoDomains';

// Logo via a curated brand→domain map (see logoDomains.ts), faviconed through
// Google's service. Falls back to homepage_url then login_url (SSO hosts are
// filtered out so the Microsoft logo / generic globe can't leak in), and to a
// letter tile when there's no usable domain or the icon 404s.
export function AppLogo({
  app,
  size = 22,
}: {
  app: Pick<CatalogApp, 'app_name' | 'display_name' | 'homepage_url' | 'login_url'>;
  size?: number;
}) {
  const [broken, setBroken] = useState(false);
  const domain = logoDomain(app);
  const label = (app.display_name ?? app.app_name).trim();
  const letter = label.charAt(0).toUpperCase() || '?';

  if (domain && !broken) {
    return (
      <Avatar
        src={`https://www.google.com/s2/favicons?domain=${domain}&sz=64`}
        alt=""
        variant="rounded"
        sx={{ width: size, height: size, bgcolor: 'transparent' }}
        slotProps={{ img: { onError: () => setBroken(true) } }}
      >
        {letter}
      </Avatar>
    );
  }
  return (
    <Avatar
      variant="rounded"
      sx={{
        width: size,
        height: size,
        fontSize: size * 0.5,
        bgcolor: 'action.selected',
        color: 'text.secondary',
      }}
    >
      {letter}
    </Avatar>
  );
}
